export default __webpack_public_path__ + "static/media/rnr-sports-table-22.d47c393d.webp";